var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 14.5,
    rx: 15,
    ry: 14.5,
    fill: "#1AB81A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.9583L12.75 19.4583L8.625 15.5625L9.6825 14.5637L12.75 17.4537L20.6925 9.95958L21.75 10.9583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveSuccess);
export default __webpack_public_path__ + "static/media/approveSuccess.ab9338ae28bb7b2320a11f907604a8db.svg";
export { ForwardRef as ReactComponent };